import { Component, Input } from '@angular/core';

@Component({
    selector: 'beaconstac-wait-loader',
    templateUrl: './wait-loader.component.html',
    standalone: false
})
export class WaitLoaderComponent {
    @Input() loadingTextArray: Array<string> = [];
    @Input() loadingText: string = '';

    constructor() {}
}
